import { render, staticRenderFns } from "./RelatedLinksEditor.vue?vue&type=template&id=38febaa2"
import script from "./RelatedLinksEditor.vue?vue&type=script&lang=ts"
export * from "./RelatedLinksEditor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports